import React, { memo } from 'react';
import styled from 'styled-components';

import { ClientCard } from '@icons/skeletons';

interface IClientCardSkeleton {
  className?: string;
}

const ClientCardSkeleton = ({ className = '' }: IClientCardSkeleton) => (
  <StyledClientCardSkeleton className={className}>
    <StyledSkeletonIcon />
  </StyledClientCardSkeleton>
);

const StyledClientCardSkeleton = styled.div`
  display: block;
`;

const StyledSkeletonIcon = styled(ClientCard)`
  width: 264px;
  height: 123px;

  animation: fade 0.1s ease;
  @keyframes fade {
    from {
      opacity: 0;
    }
  }
`;

export default memo(ClientCardSkeleton);
